// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n      ion-list {\n        padding: 0;\n      }\n      ion-item {\n        --padding-start: 16px;\n        --padding-end: 16px;\n        --min-height: 48px;\n      }\n      ion-icon {\n        font-size: 20px;\n      }\n    ", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
